
























import { Component, Prop, Vue } from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import { HsabExpenseCategory, ManagedExpenseResponse } from "@/shared/types";
import HsabExpenseCardRowExpenseDetail from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowExpenseDetail.vue";
import HsabExpenseCardRowPayee from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowPayee.vue";
import HsabExpenseCardRowDenial from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowDenial.vue";
import HsabExpenseEvidence from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseEvidence.vue";
import Pill from "@/shared/components/ui/Pill.vue";
import HsabExpenseCardRowContent from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowContent.vue";
import HsabExpenseCardRowExpenseEvidence from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowExpenseEvidence.vue";
import { useThemeStore } from "@/shared/store/theme";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import ActionNeededExpenseWidgetRow from "@/employee/components/hsabExpenses/ActionNeededExpenseWidgetRow.vue";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";
import HsabExpenseDetailsModal from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseDetailsModal.vue";
import HsabExpenseEditModal from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseEditModal.vue";
import DebitCardTransactionModal from "@/employee/components/landing-pages/hsabank/expense/DebitCardTransactionModal.vue";

@Component({
  components: {
    DebitCardTransactionModal,
    HsabExpenseEditModal,
    HsabExpenseDetailsModal,
    ActionNeededExpenseWidgetRow,
    GenericLoadingSpinner,
    HsabExpenseCardRowExpenseEvidence,
    HsabExpenseCardRowContent,
    Pill,
    HsabExpenseCardRowPayee,
    HsabExpenseCardRowExpenseDetail,
    HsabExpenseCardRowDenial,
    Button,
    CurrencyAmount,
    HsabExpenseEvidence,
  }
})
export default class HsabExpenseCardRow extends Vue {
  hsabExpenseFormStore = useHsabExpenseFormStore();
  themeStore = useThemeStore();
  thinking = false;
  @Prop({ default: true })
  showPlanName: boolean;

  @Prop({ default: false })
  showScheduleDescription: boolean;

  @Prop({ default: true })
  showSource: boolean;

  @Prop({ default: false })
  showCategory: boolean;

  @Prop({ default: true })
  showStatus: boolean;

  @Prop ()
  forceSmallScreen: boolean;

  @Prop({ required: true })
  managedExpense: ManagedExpenseResponse;

  get expenseCategory (): HsabExpenseCategory {
    return this.managedExpense.expenseCategory;
  }

  async OnRowClicked (event: UIEvent) {
    this.thinking = true;
    await this.hsabExpenseFormStore.loadManagedExpenseDetails(this.managedExpense);
    this.thinking = false;
  }
}
